import gql from "graphql-tag";
import { useTesQuery } from "./useTesQuery";

const GET_TAKEBACKS = gql`
  query GetTakebacks(
    $filter: TakebackFilterInput!
    $pagination: PaginationInput!
  ) {
    takebacks(filter: $filter, pagination: $pagination) {
      items {
        updated_at
        type_name
        timestamp
        source
        shipping_tracking_id
        shipping_provider_id
        schema_version
        quantity
        product_id
        last_processed
        id
        eventId
        deleted_at
        data
        customer_id
        created_at
        customer_id_belongsTo {
          last_name
          name
          email
        }
      }
    }
  }
`;

export const useGetTakebacks = (storeState, options = {}) => {
  const filter = {
    data: {
      hasKey: "returnMethod",
      hasValue: storeState,
    },
  };

  const pagination = {
    limit: 500,
    orderBy: "created_at",
    orderDirection: "DESC",
  };

  return useTesQuery(
    GET_TAKEBACKS,
    { filter, pagination },
    {
      enabled: Boolean(storeState),
      ...options,
    }
  );
};
